import _extends from "@babel/runtime/helpers/esm/extends";
import React, { memo, useMemo } from 'react';
import attrConvertor from 'react-attr-converter';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SVGRegExp = /<svg([^>]*)>([\s\S]*)<\/svg>/im;
var AttrRegExp = /[^=]*=("|')[^"']*("|')/g;

function Svg(props) {
  var attributes = useMemo(function () {
    var match = props.content.match(SVGRegExp);

    if (!match) {
      return {};
    }

    return match[1].trim().match(AttrRegExp).reduce(function (attrs, attr) {
      var _attr$split$map = attr.split('=').map(function (str) {
        return str.trim();
      }),
          key = _attr$split$map[0],
          val = _attr$split$map[1];

      if (key === 'class' || key === 'style') {
        return attrs;
      }

      attrs[attrConvertor(key)] = (val || key).replace(/['"]/g, '');
      return attrs;
    }, {
      dangerouslySetInnerHTML: {
        __html: match[2].trim()
      }
    });
  }, [props.content]);
  return ___EmotionJSX("svg", _extends({}, attributes, {
    className: (props.className || '') + " image",
    "data-id": props.id,
    style: props.style
  }));
}

export default /*#__PURE__*/memo(Svg);